if (!customElements.get('custom-header')) {
  class CustomHeader extends HTMLElement {
    constructor() {
      super();
      this.sectionId = this.getAttribute('data-section-id');
      this.dropdownToggles = this.querySelectorAll('[js-dropdown-toggle]');
      this.dropdownPanels = this.querySelectorAll('[js-dropdown-panel]');

      this.offcanvasTrigger = this.querySelector('.js-offcanvas-trigger');

      this.boundMouseEnterHandler = this.toggleMouseEnterHandler.bind(this);
      this.boundMouseLeaveHandler = this.toggleMouseLeaveHandler.bind(this);
      this.boundToggleMouseEnterHandler = this.toggleMouseEnterHandler.bind(this);
      this.boundPanelMouseEnterHandler = this.panelMouseEnterHandler.bind(this);
      this.boundPanelMouseLeaveHandler = this.panelMouseLeaveHandler.bind(this);
      this.boundToggleMobileMenu = this.toggleMobileMenu.bind(this);
    }

    isTouchEnabled() {
      return 'ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
    }

    connectedCallback() {
      this.dropdownToggles.forEach((toggle) => {
        toggle.addEventListener('click', this.boundToggleClickHandler);
      });

      if(window.innerWidth <= 1023) {
        this.offCanvasElement = document.querySelector('.Offcanvas--left');
        const offCanvasCloseBtn = this.offCanvasElement.querySelector('.js-offcanvas-close');
        this.overlay = document.querySelector('#js-offcanvas-bg');
        
        this.offcanvasTrigger.addEventListener('click', this.boundToggleMobileMenu);
        this.overlay.addEventListener('click', this.boundToggleMobileMenu);
        offCanvasCloseBtn.addEventListener('click', this.boundToggleMobileMenu);
      }

      if (!this.isTouchEnabled()) {
        this.dropdownToggles.forEach((toggle) => {
          toggle.addEventListener('mouseenter', this.boundToggleMouseEnterHandler);
        });
        this.dropdownPanels.forEach((panel) => {
          panel.addEventListener('mouseenter', this.boundPanelMouseEnterHandler);
          panel.addEventListener('mouseleave', this.boundPanelMouseLeaveHandler);
        });
      }
    }

    disconnectedCallback() {}

    removeFromFocusOrder = (elements) => {
      elements.forEach((element) => {
        element.setAttribute('tabindex', -1);
      });
    };

    restoreFocusOrder = (elements) => {
      elements.forEach((element) => {
        element.removeAttribute('tabindex');
      });
    };

    closeDropdown(toggleElement) {
      const dropdownId = toggleElement.getAttribute('aria-controls');
      const dropdownPanel = document.getElementById(dropdownId);
      const childLinks = dropdownPanel?.querySelectorAll('a');
      const childButtons = dropdownPanel?.querySelectorAll('button');

      toggleElement.setAttribute('aria-expanded', 'false');
      dropdownPanel?.setAttribute('aria-hidden', 'true');
      dropdownPanel?.classList.remove('visible');
      this.removeFromFocusOrder(childLinks);
      this.removeFromFocusOrder(childButtons);
    }

    openDropdown(toggleElement) {
      const dropdownId = toggleElement.getAttribute('aria-controls');
      const dropdownPanel = document.getElementById(dropdownId);
      const childLinks = dropdownPanel?.querySelectorAll('a');
      const childButtons = dropdownPanel?.querySelectorAll('button');

      this.dropdownToggles.forEach((element) => {
        this.closeDropdown(element);
      });

      toggleElement.setAttribute('aria-expanded', 'true');
      dropdownPanel?.setAttribute('aria-hidden', 'false');
      dropdownPanel?.classList.add('visible');
      this.restoreFocusOrder(childLinks);
      this.restoreFocusOrder(childButtons);
    }

    toggleDropdown(toggleElement) {
      const expanded = JSON.parse(toggleElement.getAttribute('aria-expanded'));

      if (expanded) {
        this.closeDropdown(toggleElement);
      } else {
        this.openDropdown(toggleElement);
      }
    }

    toggleClickHandler(event) {
      this.toggleDropdown(event.currentTarget);
    }

    toggleMouseEnterHandler(event) {
      this.openDropdown(event.currentTarget);
      event.currentTarget.addEventListener('mouseleave', this.boundMouseLeaveHandler);
      event.currentTarget.removeEventListener('mouseenter', this.boundMouseEnterHandler);
    }

    toggleMouseLeaveHandler(event) {
      const fromElement = event.fromElement || event.originalTarget;
      const toElement = event.toElement || event.relatedTarget;
      const sharedId = fromElement.getAttribute('aria-controls');

      if (toElement && toElement.getAttribute('id') !== sharedId) {
        const self = this;
        this.currentTimeout = setTimeout(function () {
          self.closeDropdown(fromElement);
        }, 250);
        fromElement.removeEventListener('mouseleave', this.boundMouseLeaveHandler);
        fromElement.addEventListener('mouseenter', this.boundMouseEnterHandler);
      }
    }

    panelMouseEnterHandler(event) {
      clearTimeout(this.currentTimeout);
    }

    panelMouseLeaveHandler(event) {
      const fromElement = event.fromElement || event.originalTarget;
      const toElement = event.toElement || event.relatedTarget;
      const sharedId = fromElement.getAttribute('id');
      const toggle = document.querySelector(`[aria-controls="${sharedId}"`);

      if (toElement && toElement.getAttribute('aria-controls') !== sharedId) {
        const self = this;
        this.currentTimeout = setTimeout(function () {
          self.closeDropdown(toggle);
        }, 250);
        fromElement.removeEventListener('mouseleave', this.boundMouseLeaveHandler);
        toggle?.addEventListener('mouseenter', this.boundMouseEnterHandler);
      }
    }

    toggleMobileMenu() {
      if(!this.offCanvasElement) return;

      this.offCanvasElement.classList.toggle('is-expanded');
      if(this.offCanvasElement.classList.contains('is-expanded')) {
        document.body.classList.add('has-open-offcanvas');
      } else {
        document.body.classList.remove('has-open-offcanvas');
      }
    }
  }
  customElements.define('custom-header', CustomHeader);
}
